import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section className="py-6 md:py-10 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-283">
      <FadeIn data-id="element-284">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-5 md:mb-8 tracking-tight text-[#0f172a]" data-id="element-285">
          ELEGÍ TU SISTEMA
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-286">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-287">
          <div className="bg-white border border-[#e2e8f0] rounded-2xl p-5 md:p-7 h-full flex flex-col relative hover:border-[#22c55e]/50 transition-colors shadow-sm" data-id="element-288">
            <div className="mb-3" data-id="element-289">
              <h3 className="text-lg md:text-xl font-black text-[#0f172a] flex items-center gap-2 mb-1" data-id="element-290">
                <span className="text-xl md:text-2xl" data-id="element-291">📘</span> SISTEMA CICLISTA
                PRO
              </h3>
              <p className="text-[#475569] font-bold text-xs md:text-sm" data-id="element-292">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-4 pb-4 border-b border-[#e2e8f0]" data-id="element-293">
              <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-294">
                $180.000
              </div>
              <div className="text-3xl md:text-4xl font-black text-[#0f172a] flex items-baseline gap-2" data-id="element-295">
                $19.990{' '}
                <span className="text-base text-[#475569] font-bold" data-id="element-296">ARS</span>
              </div>
            </div>

            <ul className="space-y-2 mb-5 flex-grow" data-id="element-297">
              <li className="flex items-start gap-2.5" data-id="element-298">
                <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-299">
                  <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-300" />
                </div>
                <span className="text-sm text-[#0f172a] font-bold" data-id="element-301">
                  6 Tomos completos (ruta y MTB)
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-302">
                <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-303">
                  <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-304" />
                </div>
                <span className="text-sm text-[#0f172a] font-bold" data-id="element-305">
                  6 Bonos siempre incluidos
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-306">
                <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-307">
                  <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-308" />
                </div>
                <span className="text-sm text-[#0f172a] font-bold" data-id="element-309">
                  Actualizaciones de por vida
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-310">
                <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-311">
                  <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-312" />
                </div>
                <span className="text-sm text-[#0f172a] font-bold" data-id="element-313">
                  Acceso inmediato por correo
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-314">
                <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-315">
                  <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-316" />
                </div>
                <span className="text-sm text-[#0f172a] font-bold" data-id="element-317">
                  Más de 600 páginas de contenido aplicable
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44182624534564:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#020617] hover:bg-[#0f172a] text-[#22c55e] transition-colors border border-[#0f172a]" data-id="element-318">
              → QUIERO MI SISTEMA CICLISTA PRO
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-319">
          <div className="relative h-full" data-id="element-320">
            <div className="absolute inset-0 bg-[#22c55e]/20 blur-3xl rounded-[3rem] animate-pulse" data-id="element-321"></div>
            <div className="bg-white border-2 border-[#22c55e] rounded-2xl p-5 md:p-7 h-full flex flex-col relative shadow-[0_20px_50px_rgba(34,197,94,0.15)] z-10" data-id="element-322">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#22c55e] to-[#4ade80] text-[#020617] font-black px-4 py-1 rounded-full text-xs flex items-center gap-1.5 whitespace-nowrap shadow-md" data-id="element-323">
                <Star className="w-3.5 h-3.5" fill="currentColor" data-id="element-324" /> MÁS ELEGIDO
              </div>

              <div className="mb-3 mt-3" data-id="element-325">
                <h3 className="text-lg md:text-xl font-black text-[#0f172a] flex items-center gap-2 mb-1" data-id="element-326">
                  <span className="text-2xl" data-id="element-327">🏆</span> SISTEMA CICLISTA PRO +
                  MASTER-PLAN 365
                </h3>
                <p className="text-[#16a34a] font-bold text-xs md:text-sm" data-id="element-328">
                  6 Tomos + 6 Bonos + El Cronograma de Resultados Total
                </p>
              </div>

              <div className="mb-4 pb-4 border-b border-[#e2e8f0]" data-id="element-329">
                <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-330">
                  $220.000
                </div>
                <div className="text-3xl md:text-4xl font-black text-[#0f172a] flex items-baseline gap-2" data-id="element-331">
                  $27.990{' '}
                  <span className="text-base text-[#475569] font-bold" data-id="element-332">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-2 mb-5 flex-grow" data-id="element-333">
                <li className="flex items-start gap-2.5" data-id="element-334">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-335">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-336" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-337">
                    Todo lo del Sistema Ciclista Pro
                  </span>
                </li>
                <li className="flex items-start gap-2.5 bg-[#22c55e]/10 p-2 rounded-xl border border-[#22c55e]/30 -mx-1" data-id="element-338">
                  <div className="bg-[#22c55e] p-1 rounded-full shrink-0 mt-0.5" data-id="element-339">
                    <Check className="text-[#020617]" size={14} strokeWidth={4} data-id="element-340" />
                  </div>
                  <span className="text-sm text-[#16a34a] font-black" data-id="element-341">
                    Master-Plan 365 (el GPS de implementación)
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-342">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-343">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-344" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-345">
                    Protocolo de Arranque de 7 Días
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-346">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-347">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-348" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-349">
                    Calendario Maestro de 52 Semanas
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-350">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-351">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-352" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-353">
                    Los 4 Pilares Trimestrales
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-354">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-355">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-356" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-357">
                    Calculadora de ROI y ahorro mensual
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-358">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-359">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-360" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-361">
                    5 Hojas de Ruta para situaciones especiales
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-362">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-363">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-364" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-365">
                    Contrato de compromiso anual
                  </span>
                </li>
              </ul>

              <motion.a whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} href="https://tumanualdigital.com/cart/44182625648676:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#22c55e] hover:bg-[#4ade80] text-[#020617] transition-colors shadow-[0_10px_30px_rgba(34,197,94,0.3)]" data-id="element-366">
                → QUIERO EL SISTEMA + MASTER-PLAN 365
              </motion.a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}